import React, { Fragment } from 'react'
import WorkOrdersList from '../../../../../../components/People/Member/Contract/ViewContract/WorkOrders/WorkOrdersList'
import WorkOrderModal from '../../../../../../components/People/Member/Contract/ViewContract/WorkOrders/WorkOrderModal'

const WorkOrders = props => {
  return (
    <Fragment>
      <WorkOrdersList {...props} />
      <WorkOrderModal {...props} />
    </Fragment>
  )
}

WorkOrders.propTypes = {}
WorkOrders.defaultProps = {}

export default WorkOrders
